module.exports = __webpack_public_path__ + "static/media/Quiz.9037fa39.jpg";